import { render, staticRenderFns } from "./RankReportTargeting.vue?vue&type=template&id=22a52bb7&scoped=true"
import script from "./RankReportTargeting.vue?vue&type=script&lang=js"
export * from "./RankReportTargeting.vue?vue&type=script&lang=js"
import style0 from "./RankReportTargeting.vue?vue&type=style&index=0&id=22a52bb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a52bb7",
  null
  
)

export default component.exports